var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('img',{staticStyle:{"width":"100px"},attrs:{"src":_vm.getImage()}}),_c('div',{staticStyle:{"font-size":"15px","color":"#c7c7c7","margin-top":"15px"}},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }